import { render, staticRenderFns } from "./acta-reunion.vue?vue&type=template&id=c6be03b6&"
import script from "./acta-reunion.vue?vue&type=script&lang=js&"
export * from "./acta-reunion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports